import { render, staticRenderFns } from "./UserDropDownIcon.vue?vue&type=template&id=40ecee90&scoped=true&"
import script from "./UserDropDownIcon.vue?vue&type=script&lang=js&"
export * from "./UserDropDownIcon.vue?vue&type=script&lang=js&"
import style0 from "./UserDropDownIcon.vue?vue&type=style&index=0&id=40ecee90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecee90",
  null
  
)

export default component.exports